import AdminUpdatePasein from "../../components/AdminRole/AdminRoleUpdate";

export default function UpdatePasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminUpdatePasein/>
    </div>
  );
}
